// JQUERY MAGIC
$(function () {
  console.log('RUN');
  console.log(NIRV.app_info());

  // Initialize language system early - before login/app decision
  // This ensures NIRV.L is available for both login and app screens
  console.log('🌍 Initializing language system...');
  
  // Wait for i18next to be ready, then proceed
  function initializeAndProceed() {
    if (window.NirvanaI18next && window.NirvanaI18next.initialized) {
      console.log('✅ i18next ready, applying language...');
      NIRV.applyLanguage(); // This will set up NIRV.L
      proceedWithApp();
    } else {
      console.log('⏳ Waiting for i18next...');
      // If we don't have NIRV.L yet, create a basic fallback
      if (!window.NIRV || !window.NIRV.L) {
        console.log('🔧 Creating temporary fallback NIRV.L...');
        if (window.NIRV) {
          window.NIRV.L = new Proxy({}, {
            get: (target, prop) => {
              console.warn(`Translation not ready for: ${prop}`);
              return prop; // Return the key itself as fallback
            }
          });
        }
      }
      setTimeout(initializeAndProceed, 50);
    }
  }
  
  function proceedWithApp() {
    // NIRV.L is now available for both login and app screens
    NIRV.authtoken = NIRV.storage.getItem('authtoken') || '';

    if (NIRV.authtoken == '') {
      NIRV.goLogin();
    } else {
      NIRV.goApp();
    }
  }
  
  // Start the initialization process
  initializeAndProceed();

  $.expr[':'].econtains = function (obj, index, meta, stack) {
    return (obj.textContent || obj.innerText || $(obj).text() || '') == meta[3];
  };

  $.expr[':'].eicontains = function (obj, index, meta, stack) {
    return (
      (obj.textContent || obj.innerText || $(obj).text() || '').toLowerCase() ==
      meta[3].toLowerCase()
    );
  };

  $('body')
    .on('keypress', '.bit-input input, #taglib input', function (e) {
      if (e.which == 34) return false; // "
      if (e.which == 39) return false; // '
      if (e.which == 60) return false; // <
      if (e.which == 62) return false; // >
      if (e.which == 92) return false; // \
    })
    .on('keyup', '.bit-input input, #taglib input', function (e) {
      var v = $(this).val();
      var s = v.replace(/"/g, ' ');
      s = s.replace(/'/g, ' ');
      s = s.replace(/</g, '');
      s = s.replace(/>/g, '');
      s = s.replace(/\\/g, '');
      s = s.replace(/,/g, '');
      if (s != v) {
        $(this).val(s);
      }
    });
});

